import { atom } from 'jotai';
import {
    HowLongOpts,
    OrgHistoryFilterByValue,
    SACFlavor,
    TypesOfGoodsOpts,
    WhatForOpts,
    WithWhoOpts,
    type ChangelogFilterByValue,
    type HistoryFilterByValue,
    type HistorySortByValue,
    type OrgFilterBy,
    type OrgSortBy,
} from './types';
// import { atomWithQuery } from 'jotai-tanstack-query';
// import { getCart } from './api';

// the control modal for this is currently the WelcomeModal
export const showOtherModalsAtom = atom<boolean>(false);

export const changelogFilterByAtom = atom<ChangelogFilterByValue[]>(['all']);
export const changelogSearchByAtom = atom<string>('');

export const historyFilterByAtom = atom<
  HistoryFilterByValue | OrgHistoryFilterByValue
>('sent_and_received');
export const historySortByAtom = atom<HistorySortByValue>('timestamp|desc');
export const historySearchByAtom = atom<string>('');

export const globalCartTagsAtom = atom<string[]>([]);

export const sendCartToApAtom = atom<boolean>(false);

export const extExistsAtom = atom<boolean>(false);
export const extsPresentAtom = atom<SACFlavor[]>([]);
export const extUpToDateAtom = atom<boolean>(false);

export const getStepAtom = atom<1 | 2 | 3 | 4>(1);
export const getCartIdAtom = atom<string>('');
// The extension reported that the receive failed (useReceiveLogic). Shared rather than the hook's own
// state: the extension says it once, and some of the hook's users (the timeout modal) mount only after
// the cart has loaded, which on a slow connection can be later.
export const receiveFailedAtom = atom<boolean>(false);
export const reviewCartIdAtom = atom<string>('');

export const showEmbedModalAtom = atom<boolean>(false);

export const showExtensionLoadingModalAtom = atom<boolean>(false);
export const showExtensionMissingModalAtom = atom<boolean>(false);

export const showChunkCartModalAtom = atom<boolean>(false);
export const chunkLinksAtom = atom<string[]>([]);

export const showFeedbackModalAtom = atom<boolean>(false);

// Cart History Import States
export const showCartsImportedModalAtom = atom<boolean>(false);
export const numberOfCartsImportedAtom = atom<number | null>(null);
export const cartImportErrorAtom = atom<boolean>(false);
export const cartImportPendingAtom = atom<boolean>(false);

// The Deals nag (promotional speech-bubble) is the lowest-priority "follower"
// modal: it never blocks other modals, won't open while one is up, and closes
// itself if a functional modal opens (see useShowDealsNag). This derived atom is
// true when any blocking/functional modal is currently open — the nag yields to
// all of these.
export const anyBlockingModalOpenAtom = atom((get) =>
  get(showFeedbackModalAtom) ||
  get(showEmbedModalAtom) ||
  get(showExtensionLoadingModalAtom) ||
  get(showExtensionMissingModalAtom) ||
  get(showChunkCartModalAtom) ||
  get(showCartsImportedModalAtom),
);

// User Survey States
export const whatForSelectedAtom = atom<WhatForOpts[]>([]);
export const whatForTextAtom = atom<string>('');

export const howLongSelectedAtom = atom<HowLongOpts | undefined>(undefined);

export const withWhoSelectedAtom = atom<WithWhoOpts[]>([]);
export const withWhoTextAtom = atom<string>('');

export const typesOfGoodsSelectedAtom = atom<TypesOfGoodsOpts[]>([]);
export const typesOfGoodsTextAtom = atom<string>('');

// Organization Atoms
// Org Settings
export const orgTotalUsersAtom = atom<number>(0);
export const orgFilterByAtom = atom<OrgFilterBy>('all');
export const orgSortByAtom = atom<OrgSortBy>('role');
export const orgSearchByAtom = atom<string>('');
export const orgDebounceDelayAtom = atom<number>(500);

// Org Cart Analytics
export const orgCartAnalyticsStartDateAtom = atom<string>('');
export const orgCartAnalyticsEndDateAtom = atom<string>('');
export const orgCartAnalyticsSelectedRequestersAtom = atom<string[]>([]);
export const orgCartAnalyticsSelectedVendorsAtom = atom<string[]>([]);

// Cookie consent: which analytics services are enabled (GTM, LiveSession, PostHog)
export type AnalyticsConsentState = {
  gtm: boolean;
  liveSession: boolean;
  posthog: boolean;
};
/** Opt-out default: all analytics services enabled until user opts out. */
export const analyticsConsentAtom = atom<AnalyticsConsentState>({
  gtm: true,
  liveSession: true,
  posthog: true,
});

export const dealsVendorAtom = atom<string | null>(null);
export const vendorHasDealsAtom = atom<boolean>(false);
